
declare global {
  interface Window {
    sbvrenv: any;
  }
}

import './core/setup/env';
import './core/setup/vue';
import Vue from 'vue';
import { initStore, initGQL } from '@sbvr/lbe-compositions';
import gql from './core/setup/api';
import i18n from './core/i18n';
import router from './core/routes';
import store from './core/store';
import App from './App.vue';

initGQL(gql);
initStore(gql);

Vue.config.productionTip = false;
new Vue({
  router,
  store,
  i18n,
  render (h) {
    return h(App, []);
  },
}).$mount('#app');
